import React, { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "@/lib/i18n";

const Ctx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sdm_lang") || "es");
  useEffect(() => localStorage.setItem("sdm_lang", lang), [lang]);
  const t = (k) => TRANSLATIONS[lang]?.[k] || k;
  const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));
  return <Ctx.Provider value={{ lang, setLang, toggle, t }}>{children}</Ctx.Provider>;
}
export const useLang = () => useContext(Ctx);
